module.exports = __webpack_public_path__ + "static/img/authorize-bg.008a5b34.png";